import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { Globe, Church, Sparkles } from 'lucide-react';

export const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="relative">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gradient-to-br from-gold to-gold-dark flex items-center justify-center shadow-soft">
                <Church className="w-5 h-5 sm:w-6 sm:h-6 text-primary-foreground" />
              </div>
              <Sparkles className="absolute -top-1 -right-1 w-4 h-4 text-gold animate-pulse" />
            </div>
            <div className="hidden sm:block">
              <h1 className="font-heading text-xl sm:text-2xl font-semibold text-foreground">
                {language === 'fr' ? 'Mon Saint Patron' : 'My Patron Saint'}
              </h1>
              <p className="text-xs text-muted-foreground">
                {language === 'fr' ? 'Découvrez votre protecteur céleste' : 'Discover your heavenly protector'}
              </p>
            </div>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <a href="#search" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
              {t('nav.search')}
            </a>
            <a href="#features" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
              {t('nav.about')}
            </a>
          </nav>

          {/* Language Toggle */}
          <div className="flex items-center gap-4">
            <Button 
              variant="divine" 
              size="sm"
              onClick={toggleLanguage}
              className="gap-2"
            >
              <Globe className="w-4 h-4" />
              <span className="uppercase font-semibold">{language === 'fr' ? 'EN' : 'FR'}</span>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
